import { __assign } from "tslib";
import { PerfClient } from '@baidu/weirwood-perf';
import { ErrorClient } from '@baidu/weirwood-error';
import { getGlobal, getNow, isNative, routeHook, uuid4 } from './utils';
/** 统一的客户端类 */
var Client = /** @class */ (function () {
    function Client(options) {
        /** 版本号，发布时需要手动修改，后续看能否自动化 */
        this.version = '1.3.12';
        // 上次路由跳转时间
        this.lastRouteTime = 0;
        if (options) {
            this.init(options);
        }
    }
    Client.prototype.init = function (options) {
        // TODO 异常和性能的options中的sendwindow和uuid4是透传下去公共使用，之后应该对公共方法提取公共的common包
        var sendWindow = this.getSendWindow();
        // 1. 如果不提供 perf 配置，那么开启默认配置
        // 2. 如果提供了 perf 配置，且 disable 属性为任意 true 值，那么不开启性能监控
        if (!options.perf || (options.perf && !options.perf.disable)) {
            var perfOptions = __assign(__assign(__assign({}, options.perf), options.common), { version: this.version, sendWindow: sendWindow });
            this.perf = new PerfClient(perfOptions);
        }
        // 1. 如果不提供 error 配置，那么开启默认配置
        // 2. 如果提供了 error 配置，且 disable 属性为任意 true 值，那么不开启异常监控
        if (!options.error || (options.error && !options.error.disable)) {
            var errorOptions = __assign(__assign(__assign({}, options.error), options.common), { version: this.version, sendWindow: sendWindow, uuid4: uuid4 });
            this.error = new ErrorClient(errorOptions);
        }
        this.routeChange(window.document.URL);
        routeHook(this.routeChange.bind(this));
    };
    Client.prototype.routeChange = function (url) {
        var now = getNow();
        if (now - this.lastRouteTime > 100) {
            this.lastRouteTime = now;
            var pageId = uuid4() + "-" + now;
            this.error && this.error.setContext({ pageId: pageId });
        }
    };
    /**
     * 判断fetch/ajax/sendBeacon是否是native code 不是则获取iframe的window对象
     */
    Client.prototype.getSendWindow = function () {
        var _window = getGlobal();
        // 判断是否有被重写的方法
        var funcs = ['fetch', 'ajax', 'sendBeacon'];
        var needIframe = funcs.some(function (v) { return !isNative(window[v]); });
        // 有被重写的方法创建iframe
        if (needIframe && document.body) {
            var iframe = document.createElement('iframe');
            iframe.style.setProperty('display', 'none', 'important');
            document.body.appendChild(iframe);
            _window = iframe ? iframe.contentWindow : _window;
        }
        return _window;
    };
    Client.prototype.afterLoad = function () { };
    return Client;
}());
export { Client };
/**
 * 初始化函数，挂载一个默认实例到 window 对象，可以通过 __Weirwood 访问，或者保存返回变量
 * @returns 默认的实例对象
 */
export function init(options) {
    var _global = getGlobal();
    // 如果已经存在，直接返回已经存在的实例
    if (_global['__Weirwood']) {
        return _global['__Weirwood'];
    }
    // 否则新建一个实例返回
    var defaultInstance = new Client(options);
    defaultInstance.afterLoad();
    _global['__Weirwood'] = defaultInstance;
    return defaultInstance;
}
//# sourceMappingURL=index.js.map